module.exports = __webpack_public_path__ + "img/syl_gallery12.850a74a7.jpg";